export class Suffix {
    public static SuffixList: Array<any> = [
        { name: 'Jr.', value: 'Jr.' },
        { name: 'Sr.', value: 'Sr.' },
        { name: 'II', value: 'II' },
        { name: 'III', value: 'III' },
        { name: 'IV', value: 'IV' },
        { name: 'V', value: 'V' },
    ];
}
